import { render, staticRenderFns } from "./BrowserSupport.vue?vue&type=template&id=761d8c81&scoped=true"
import script from "./BrowserSupport.vue?vue&type=script&lang=js"
export * from "./BrowserSupport.vue?vue&type=script&lang=js"
import style0 from "./BrowserSupport.vue?vue&type=style&index=0&id=761d8c81&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761d8c81",
  null
  
)

export default component.exports